





































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import MathSubPackSvg from 'frontend/views/premium/paywall/svgs/MathSubPackSvg.vue';
import { MobileGetter } from 'frontend/types';
import CourseSubpackInterestModal from 'frontend/views/premium/paywall/CourseSubpackInterestModal.vue';
import PaywallPlan from 'frontend/views/premium/PaywallPlan.vue';

interface SubPackInput {
  plan_id: number;
}

@Component({
  components: { PaywallPlan, CourseSubpackInterestModal, MathSubPackSvg },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapGetters('globals', ['inExperiment']),
  },
})
export default class CourseSubPack extends Vue {
  private isMobile!: MobileGetter;
  private showModal = false;

  private mathSubPack = {
    display_name: 'Math plan',
    display_price: '$4.99',
    checkout_url: '',
    interval: 'annual',
    price_vendor: 'corrily',
  };
}
